import { useSystemSettingsStore } from "./store";

export const list = () => useSystemSettingsStore.getState().list();

export const batchUpdate = (objects: any) =>
  useSystemSettingsStore.getState().batchUpdate(objects);

